import React from 'react';
import '../styles/CTASection.css';
import { appendUtmParams } from '../utils/utm-params';

const CTASection = ({ 
  title,
  subtitle,
  buttonText,
  buttonLink,
  date,
  venue,
  location
}) => {
  // Handle click to append UTM parameters
  const handleClick = (e) => {
    e.preventDefault();
    const urlWithParams = appendUtmParams(buttonLink);
    window.location.href = urlWithParams;
  };

  return (
    <section className="cta-section">
      <div className="container">
        <div className="cta-card">
          <div className="cta-content-wrapper">
            {/* Left Side - CTA Text & Button */}
            <div className="cta-text-content">
              <h2 className="cta-title">{title}</h2>
              <p className="cta-subtitle">{subtitle}</p>
              <a href={buttonLink} onClick={handleClick} className="cta-button">
                {buttonText}
              </a>
            </div>

            {/* Right Side - Event Details */}
            <div className="cta-event-details">
              <div className="cta-date">{date}</div>
              <div className="cta-venue">{venue}</div>
              <div className="cta-location">{location}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;

